import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  JobSchedulePhaseViewModel,
  JobScheduleViewModel,
} from '../models/JobScheduleViewModel';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WizardService {
  observeResponse: any = { observe: 'response' };
  textResponseType: any = { responseType: 'text' };
  apiPrefix = '/JobSchedule/';

  constructor(private readonly http: HttpClient) {}

  CancelJob(jobScheduleId: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'CancelJob?jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  UnCancelJob(jobScheduleId: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'UnCancelJob?jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  CopyJobSchedule(jobScheduleId: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'CopyJobSchedule?jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  DeleteJobSchedule(jobScheduleId: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'DeleteJobSchedule?jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  MarkAsRainedOut(jobScheduleId: any, rainedOut: boolean): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'MarkAsRainedOut?jobScheduleId=' +
        jobScheduleId +
        '&rainedOut=' +
        rainedOut,
      { ...this.observeResponse }
    );
  }

  InspectorCalled(jobScheduleId: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'InspectorCalled?jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  InspectorNeeded(jobScheduleId: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'InspectorNeeded?jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  SubmitJobSchedule(jobScheduleSubmitViewModel: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint + this.apiPrefix + 'SubmitJobSchedule',
      jobScheduleSubmitViewModel,
      { ...this.observeResponse }
    );
  }

  SendDailyJobSchedule(
    startDate: any,
    isTentativeScheduleEmail: boolean
  ): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'SendDailyJobSchedule?startDate=' +
        startDate.toLocaleString() +
        '&isTentativeScheduleEmail=' +
        isTentativeScheduleEmail,
      { ...this.textResponseType }
    );
  }

  SendDailyJobScheduleTextMessage(
    startDate: any,
    showAllJobs: boolean
  ): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'SendDailyJobScheduleTextMessage?startDate=' +
        startDate.toLocaleString() +
        '&showAllJobs=' +
        showAllJobs,
      { ...this.textResponseType }
    );
  }

  GetAllActivePhases(form: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetAllActivePhasesByFilterCriteria',
      form,
      { ...this.observeResponse }
    );
  }

  InsertOrUpdateStep2JobScheduleData(
    jobScheduleViewModel: JobScheduleViewModel
  ): Observable<any> {
    return this.http.post<JobSchedulePhaseViewModel>(
      environment.apiEndPoint +
        this.apiPrefix +
        'InsertOrUpdateStep2JobScheduleData',
      jobScheduleViewModel,
      { ...this.observeResponse }
    );
  }

  GetJobScheduleDataByJobScheduleId(scheduleId: any): Observable<any> {
    return this.http.get(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetJobScheduleDataByJobScheduleId?jobScheduleId=' +
        scheduleId,
      { ...this.observeResponse }
    );
  }

  GetAuditHistoryByJobScheduleId(scheduleId: any): Observable<any> {
    return this.http.get(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetAuditHistoryByJobScheduleId?jobScheduleId=' +
        scheduleId,
      { ...this.observeResponse }
    );
  }

  // Different API Prefix
  GetAllCompanies(): Observable<any> {
    return this.http.get(
      environment.apiEndPoint + '/Company/GetAllActiveCompanies',
      { ...this.observeResponse }
    );
  }

  GetAllJobsByCompanyId(companyID: number, startDate: any): Observable<any> {
    return this.http.get(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetAllJobsByCompanyId?companyId=' +
        companyID +
        '&startDate=' +
        startDate,
      { ...this.observeResponse }
    );
  }

  GetAllJobs(): Observable<any> {
    return this.http.get(environment.apiEndPoint + this.apiPrefix + 'GetAllJobs', {
      ...this.observeResponse,
    });
  }

  GetAllItems(): Observable<any> {
    return this.http.get(environment.apiEndPoint + this.apiPrefix + 'GetAllItems', {
      ...this.observeResponse,
    });
  }

  GetAllContractItemsByCompanyIdAndContractId(
    companyID: number,
    contractId: number
  ): Observable<any> {
    return this.http.get(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetAllContractItemsByCompanyIdAndContractId?companyId=' +
        companyID +
        '&contractId=' +
        contractId,
      { ...this.observeResponse }
    );
  }

  GetAllActivePhasesByFilterCriteria(form: any): Observable<any> {
    return this.http.post(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetAllActivePhasesByFilterCriteria',
      form,
      { ...this.observeResponse }
    );
  }

  GetAllEmployeesByCompanyId(
    companyID: number,
    jobScheduleId: any
  ): Observable<any> {
    return this.http.get(
      environment.apiEndPoint +
        this.apiPrefix +
        'GetAllEmployeesByCompanyId?companyId=' +
        companyID +
        '&jobScheduleId=' +
        jobScheduleId,
      { ...this.observeResponse }
    );
  }

  InsertOrUpdateStep1JobScheduleData(form: JobScheduleViewModel): Observable<any> {
    return this.http.post<JobSchedulePhaseViewModel>(
      environment.apiEndPoint +
        this.apiPrefix +
        'InsertOrUpdateStep1JobScheduleData',
      form,
      { ...this.observeResponse }
    );
  }

  InsertOrUpdateJobSchedule(form: any): Observable<any> {
    return this.http.post<JobSchedulePhaseViewModel>(
      environment.apiEndPoint + this.apiPrefix + 'InsertOrUpdateJobSchedule',
      form,
      { ...this.observeResponse }
    );
  }
}
